<template>
	<div class="profile-wrapper">
		<div class="title">活动列表</div>
		<div class="active-wrapper">
			<div class="active-item" v-for="item in dataList">
				<el-image class="cover" :src="item.url" fit="fill"></el-image>
					
			</div>
		</div>
	</div>
</template>

<script>
import EventBus from '@/utils/eventHub.js'
import { getIsTrial, getToken } from '@/utils/auth'
export default {
  data () {
    return {
      dataList: [{
		  url:require('@/assets/activity-image.png')
	  },{
		  url:require('@/assets/activity-image.png')
	  }]
    }
  },
  methods: {
    
  },
  mounted () {
	  
  }

}
</script>

<style lang="scss" scoped>
.profile-wrapper{
	padding: 30px 40px;
	.title{
		font-size: 20px;
		font-weight: 800;
		border-bottom: 1px solid #D4D4E6;
		padding-bottom: 10px;
	}
	.active-wrapper{
		margin: 20px 0;
		display: flex;
		flex-wrap: wrap;
		.active-item{
			flex: 0 0 49%;
			box-sizing: border-box;
			margin: 0 1% 1% 0;
			.cover{
				width: 100%;
				height: 180px;
			}
		}
	}
}	

</style>